export const POST_FEEDBOX_LIST_POSTS_ENDPOINT = "/feedbox/v1alpha1/list-posts"
export const GET_FEEDBOX_POSTS_ENDPOINT = "/api/feedbox/v1/posts"
export const GET_FEEDBOX_SAVED_POSTS_ENDPOINT = "/api/feedbox/v1/saved_posts"
export const GET_FEEDBOX_APPLIED_POSTS_ENDPOINT = "/api/feedbox/v1/applied_posts"
export const GET_FEEDBOX_LIST_RECOMMENDATIONS_ENDPOINT = "/v1/feedbox/recommendations"
export const LIMIT_RESPONSE_TIME = 2000
